module.exports = __webpack_public_path__ + "static/media/HIPERCARD.b00e9fa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/HIPERCARD.svg
// module id = 79
// module chunks = 0